import React, { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import ApiService from '@services/api';
import companyStore from '@store/Company';
import settingsStore from '@store/SettingsStore';
import logo from '@assets/logo.svg';
import { Container, Content, NavigationLink } from './styles';

const Header: React.FC = observer(() => {
  const location = useLocation();

  const token = useMemo(() => {
    const segments = location.pathname.split('/');
    // Conforme definido em routes.tsx, o token aparece como o segundo segmento
    // Ex: /settings/TOKEN ou /nfe/TOKEN
    if (segments.length === 3) return segments[2];
    return undefined;
  }, [location.pathname]);

  const { api } = useMemo(() => new ApiService(token), [token]);

  useEffect(() => {
    async function loadData() {
      try {
        companyStore.reset();
        settingsStore.reset();
        await Promise.all([companyStore.load(api), settingsStore.load(api)]);
      } catch (error) {
        console.error('Erro ao carregar dados do Header:', error);
      }
    }

    loadData();
  }, [api]);

  return (
    <Container>
      <Content>
        <img src={logo} alt="Portal DF-e" />

        {companyStore.company && (
          <nav>
            {(settingsStore.nfe.enabled ||
              settingsStore.nfce.enabled ||
              settingsStore.nfse.enabled) && (
              <NavigationLink to="/nfe">Notas</NavigationLink>
            )}
            {settingsStore.cte.enabled && (
              <NavigationLink to="/cte">Transportes</NavigationLink>
            )}
            {settingsStore.mdfe.enabled && (
              <NavigationLink to="/mdfe">Manifestos</NavigationLink>
            )}
            {(settingsStore.nfe.enabled || settingsStore.nfce.enabled) && (
              <NavigationLink to="/inutilizacao">Inutilizações</NavigationLink>
            )}
            {settingsStore.email?.smtp?.host && (
              <NavigationLink to="/email-logs">
                Histórico de E-mails
              </NavigationLink>
            )}
            <NavigationLink to="/xml">Downloads</NavigationLink>
            <NavigationLink to="/settings">Configurações</NavigationLink>
          </nav>
        )}
        <aside>
          {companyStore.company && (
            <span
              style={{ fontWeight: 'bold', color: '#666', fontSize: '14px' }}
            >
              {companyStore.company.nickName}
            </span>
          )}
        </aside>
      </Content>
    </Container>
  );
});

export default Header;
